<template>
  <div class="dongtai">
    <!-- banner -->
    <div class="banner">
      <img src="../../../assets/images/dongtai/banner.png" alt="" />
    </div>
    <!-- 标题 -->
    <div class="biaoti">
      <img src="../../../assets/images/dongtai/biaoti.png" alt="" />
    </div>
    <!-- 列表 -->
    <div class="lie">
      <ul>
        <li
          v-for="(item, index) in zhengceList"
          :key="index"
          @click="handleClick(item)"
        >
          <img src="../../../assets/images/dongtai/dian.png" alt="" />
          <p>{{ item.Extend1 }}</p>
        </li>
      </ul>
      <a href="javascript:;" class="problem_more" @click="LoadMore">{{
        jzTxt
      }}</a>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Bottom from "@/P09_BaiCaiHui/components/Foot.vue";
export default {
  components: {
    Bottom,
  },
  metaInfo() {
    return {
      title: "上海落户政策-落户规定-条件-百才汇",
      meta: [
        {
          name: "keywords",
          content: "上海落户政策,上海落户规定",
        },
        {
          name: "description",
          content:
            "百才汇要闻动态,提供上海落户政策、上海落户规定、条件等内容,收集更新实时动态,掌握落户信息！",
        },
      ],
    };
  },
  data() {
    return {
      zhengceList: [],
      pagination: {
        // 总条数
        total: 0,
        // 当前页码
        currentPage: 1,
        // 默认多少条数
        pagesize: 10,
      },
      //list加载
      jzTxt: "点击加载更多",
      isLoad: true,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 点击跳转
    handleClick(item) {
      this.$router.push("/luohuxiangqing/" + item.WebsiteContentId + ".html");
    },
    // 加载更多
    LoadMore() {
      if (!this.isLoad) return false;
      this.getData();
    },
    // 获取问答列表
    getData(ispull) {
      this.jzTxt = "加载中...";
      this.$axios
        .post("/trip/TokenPass/GetHantengPublishMenuContent", {
          WebsiteMenuId: 329,
          index: this.pagination.currentPage,
          size: this.pagination.pagesize,
        })
        .then((res) => {
          if ((res.data.Code = 200)) {
            this.jzTxt = "点击加载更多";
            this.zhengceList = this.zhengceList.concat(res.data.Data.list);
            if (this.zhengceList.length >= res.data.DataCount) {
              this.isLoad = false;
              this.jzTxt = "没有更多了";
            }
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
      this.pagination.currentPage++;
    },
  },
};
</script>

<style lang="scss" scoped>
.dongtai {
  margin-top: 80px;
  //   banner
  .banner {
    width: 100%;
    height: 200px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  //   标题
  .biaoti {
    width: 340px;
    height: 36px;
    margin: auto;
    margin-top: 60px;
    margin-bottom: 40px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  //   列表
  .lie {
    padding: 0px 40px;
    box-sizing: border-box;
    ul {
      width: 670px;
      margin: auto;
      border-top: 1px solid #ececec;
      li {
        width: 100%;
        height: 100px;
        border-bottom: 1px solid #ececec;
        display: flex;
        img {
          width: 8px;
          height: 8px;
          margin-top: 46px;
        }
        p {
          margin-left: 20px;
          font-size: 22px;
          font-weight: 400;
          color: #333333;
          line-height: 100px;
          overflow: hidden;
          text-overflow: ellipsis; /*超出则...代替*/
          display: -webkit-box;
          -webkit-line-clamp: 1; /* 行数*/
          line-clamp: 1; /*行数*/
          -webkit-box-orient: vertical;
        }
      }
    }
    .problem_more {
      display: block;
      font-size: 22px;
      color: #fff;
      background-color: #cbb486;
      height: 60px;
      line-height: 60px;
      text-align: center;
      margin: 0 auto;
      margin-top: 50px;
      width: calc(100% - 60px);
      text-decoration: none;
      border-radius: 8px;
      margin-bottom: 26px;
      letter-spacing: 1px;
    }
  }
}
</style>